import * as React from "react";
import Footer from "./Footer";

export default function () {
    return (
        <Footer
            title="内蒙古大学精英学生开发者联盟版权所有"
        />
    );
}